import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer, closeDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { FieldOption } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import { useState } from "react";
import FieldOptionForm from "./fieldOptionForm";
import { Input } from "@/src/components/universalInput";
import { ReorderableItems } from "@/src/components/reorderable";
import { MdOutlineDragIndicator } from "react-icons/md";

export default function ReorderableOptions({
  currentValue,
  onChange,
}: {
  currentValue: (FieldOption | null | undefined)[];
  onChange: (newValue: (FieldOption | null | undefined)[]) => void;
}) {
  const [selectedOptions, setSelectedOptions] = useState(currentValue);
  const [reload, setReload] = useState(0);
  const [newOptionName, setNewOptionName] = useState("");

  function addOption({ name }: { name: string }) {
    let option: FieldOption = {
      name,
      description: "",
      value: "",
      creator: getUserId(),
    };

    setSelectedOptions([...selectedOptions, option]);
    onChange([...selectedOptions, option]);
    setNewOptionName("");
    setReload(reload + 1);
  }

  return (
    <div className="grid c1 gap10">
      <label>Options</label>

      {selectedOptions.length != 0 && (
        <div className="grid c1 gap10">
          <ReorderableItems
            items={selectedOptions || []}
            listId="optionsList"
            listType={"optionsList"}
            onReorder={(newItems) => {
              onChange(newItems);
              setSelectedOptions(newItems);
            }}
          >
            {selectedOptions?.map((option, index) => {
              return (
                <Card
                  key={uid()}
                  color="simple"
                  leading={
                    <div className="grab disabled">
                      <MdOutlineDragIndicator size={15} />
                    </div>
                  }
                  onDelete={async () => {
                    let newSelectedOptions = [
                      ...selectedOptions.filter((o) => o?.name != option?.name),
                    ];
                    setSelectedOptions(newSelectedOptions);
                    onChange(newSelectedOptions);
                    setReload(reload + 1);
                  }}
                  onEdit={async () => {
                    await openDrawer({
                      title: "Option",
                      content: (
                        <FieldOptionForm
                          currentData={option}
                          onChange={(newValue) => {
                            option = newValue;
                          }}
                        />
                      ),
                      onConfirm: async () => {
                        if (!option) throw new Error("No option found");
                        let inserted = await apiFetch(
                          "fieldOptions",
                          "addOne",
                          {
                            option,
                          }
                        );
                        selectedOptions[index] = inserted;
                        setSelectedOptions([...selectedOptions]);
                        onChange([...selectedOptions]);
                        setReload(reload + 1);
                      },
                    });
                  }}
                >
                  <div>{option?.name}</div>
                </Card>
              );
            })}
          </ReorderableItems>
        </div>
      )}

      <div className="c1-auto gap10">
        <Input
          key={`optionText-${reload}`}
          shouldFocus={true}
          name=""
          type="text"
          placeholder="Ajouter une option"
          value={newOptionName}
          onKeyUp={(e) => {
            if (e.key == "Enter") addOption({ name: newOptionName });
          }}
          onChange={(newValue) => {
            setNewOptionName(newValue);
          }}
        />
        <Button
          type="tertiary"
          onClick={async (e) => {
            addOption({ name: newOptionName });
          }}
        >
          +
        </Button>
      </div>
    </div>
  );
}
